import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectItem} from "primeng/api";
import {SkillData} from "../../Models/Holders/techRadarDataHolder.model";
import { NgClass } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
    selector: 'skill-survey',
    templateUrl: 'skill-survey.component.html',
    styleUrls: ['techRadar.component.css'],
    imports: [NgClass, ReactiveFormsModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkillSurveyComponent {

  @Input() skills: SkillData[] = [];

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  skillLevels: SelectItem[] = [
    {label: 'NONE', value: 'NONE'},
    {label: 'NOTIONS', value: 'NOTIONS'},
    {label: 'PROEFFICIENT', value: 'PROEFFICIENT'}
  ];

  triggerChange = () => {
    this.onChange.emit();
  }
}
